module.exports = __webpack_public_path__ + "img/progress_4.7fabf1cd.png";